import { Helmet } from 'react-helmet-async';
import React from 'react';
import InitiativeDetailContainer from '../../containers/initiatives/InitiativeDetailContainer.jsx';
import { getOrgTermsContent } from '../../content/utils.js';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

const ShowInitiative = (props) => {
  const {
    initiativeId,
    initiativeType,
    initiativeParticipationId,
    stakeholderParticipationId,
    slug,
  } = props;

  return (
    <>
      <Helmet>
        <title>{getOrgTermsContent('initiatives')} | ChangeSync</title>
      </Helmet>
      <InitiativeDetailContainer
        isPreview={false}
        slug={slug}
        initiativeId={initiativeId}
        initiativeType={initiativeType}
        initiativeParticipationId={initiativeParticipationId}
        stakeholderParticipationId={stakeholderParticipationId}
      />
    </>
  );
};

ShowInitiative.getInitialProps = ({ query }) => ({
  initiativeId: Number(query.initiativeId),
  initiativeType: query.initiativeType,
  slug: query.slug,
  initiativeParticipationId: query.participant
    ? Number(query.participant)
    : null,
  stakeholderParticipationId: query.stakeholder
    ? Number(query.stakeholder)
    : null,
});

export default requireAuth(withRouterParams(ShowInitiative));
